module.exports =
  "_BROWSER":
    "PRIVATE_MODE_ALERT_MESSAGE": "本サイトはプライベートモードによるブラウジングをサポートしていません。お手数ですが、プライベートモードを無効にして再度お試し下さい。"
    "BLOCK_COOKIE_ALERT_MESSAGE": "cookie が無効になっているためサイトを表示できません。お手数ですが「設定 > Safari > プライバシーとセキュリティ」から cookie を許可して、再度お試し下さい。"




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/browser/i18n/ja.coffee